import { useTranslation } from "react-i18next";

import { Grid2 } from "@mui/material";

import { useGetCurrentUserAgent } from "../../../../../../../hooks";
import { useMainForm } from "../../../../../../../hooks/use-main-form";

import { Checkbox, Input } from "../../../../../../../components";
import { SelectAndSearch } from "../../../../../../../components/ui/SelectAndSearch/SelectAndSearch";

import {
  BoxButton,
  FormControlLabelStyled,
  FormGroupStyled,
  FormWrapper,
  GridItem,
  SearchButton,
} from "./Form.styled";

export const Form = ({ url }) => {
  const { t } = useTranslation();

  // for current User-Agent
  const { userAgent } = useGetCurrentUserAgent();
  const name = t("global.myUserAgent");
  const fingerPrintOption = { id: "-1", userAgent, name };
  // for current User-Agent

  // const plainOptions = t("mainForm.options", { returnObjects: true });
  const plainOptions = {
    removePageTitle: t("mainForm.options.removePageTitle"),
    allowCookies: t("mainForm.options.allowCookies"),
    deleteScripts: t("mainForm.options.deleteScripts"),
  };

  const {
    formData,
    handleSubmit,
    handleChange,
    handleCheckboxChange,
    urlRef,
    countryRef,
    userAgentRef,
    mainPageData,
    capitalizeDataCountry,
    isLoading,
  } = useMainForm(url);

  return (
    <FormWrapper
      method="POST"
      target="_blank"
      action={"/api/front/proxy"}
      onSubmit={handleSubmit}
    >
      <Grid2
        container
        rowSpacing={{ xs: 2 }}
        columnSpacing={{ xs: 0, sm: 2.5 }}
      >
        <Grid2 size={{ xs: 12, sm: 6, lg: 3.1 }}>
          <Input
            name="url"
            onChange={handleChange}
            fullWidth
            placeholder={t("mainForm.inputPlaceholder")}
            value={formData.url}
            ref={urlRef}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, lg: 3.5 }}>
          <SelectAndSearch
            selectName="name"
            data={mainPageData?.fingerprints}
            isLoading={isLoading}
            placeholder={t("mainForm.selectUserAgent")}
            handleChange={handleChange}
            name="fingerprintUserAgent"
            refSelect={countryRef}
            type="form"
            selectOption={"userAgent"}
            fingerPrintOption={fingerPrintOption}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, lg: 3.05 }}>
          <SelectAndSearch
            selectName="name"
            data={capitalizeDataCountry}
            isLoading={isLoading}
            placeholder={t("mainForm.selectCountry")}
            handleChange={handleChange}
            name="proxyServerId"
            refSelect={userAgentRef}
            type="form"
            showFlag
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, lg: 2.35 }}>
          <BoxButton>
            <SearchButton currentClass="primaryBtn" type="submit" fullWidth>
              {t("global.searchPage")}
            </SearchButton>
          </BoxButton>
        </Grid2>
        <GridItem size={{ xs: 12, sm: 12 }}>
          <FormGroupStyled row={true}>
            {Object.keys(plainOptions).map((key, i) => (
              <FormControlLabelStyled
                key={i}
                control={
                  <Checkbox
                    color="primary"
                    name={key}
                    checked={formData[key]}
                    onChange={handleCheckboxChange}
                    value={formData[key] ? "true" : "false"}
                  />
                }
                label={plainOptions[key]}
              />
            ))}
          </FormGroupStyled>
        </GridItem>
      </Grid2>
    </FormWrapper>
  );
};
